import React from "react";

// state
import { useDispatch } from "react-redux";
import { getAllCompaniesFile } from "../../../services/apis/companiesFile";

const useDashboard = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = React.useState(false);
  const [viewEdit, setViewEdit] = React.useState(false);
  const [viewOne, setViewOne] = React.useState(false);
  const [viewOp, setViewOp] = React.useState({});
  const [edit, setEdit] = React.useState({});

  const onSearch = (value) => console.log(value);

  const onCloseModal = () => {
    setVisible(false);
  };
  const editOpen = (data) => {
    setEdit(data);

    setViewEdit(true);
  };
  const viewOpen = (data) => {
    setViewOp(data);
    setViewOne(true);
  };
  const onCloseView = () => {
    setViewOne(false);
  };
  const onCloseEdit = () => {
    setViewEdit(false);
  };

  const onLoad = React.useCallback(() => {
    getAllCompaniesFile(dispatch);
  }, [dispatch]);

  return {
    onLoad,
    editOpen,
    viewOpen,
    onCloseEdit,
    onCloseView,
    setEdit,
    viewOne,
    viewOp,
    edit,
    viewEdit,
    visible,
    setVisible,
    onCloseModal,
    onSearch,
  };
};

export default useDashboard;
